import { createStore } from 'vuex'
import user from './modules/user'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    user
  }
})
